import { Link } from "react-router-dom";
import LogoMark from "@/components/LogoMark";
import { DISPATCH_PHONE_DISPLAY, DISPATCH_TEL_HREF } from "@/lib/contact";

const NY_REGIONS = ["New York City", "JFK", "LaGuardia", "Newark (EWR)", "The Hamptons"];
const MA_REGIONS = ["Boston", "Logan Airport", "Chelmsford", "Worcester"];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0B0B0C] mt-0"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <LogoMark size="lg" />
          <p className="mt-6 text-sm text-[#8E9AA6] max-w-sm leading-relaxed">
            Available 24/7 across New York &amp; Massachusetts. Elite chauffeured transportation
            for executives, weddings, corporate events, and private travel.
          </p>
          <div className="mt-8 space-y-2">
            <a
              href="mailto:reservations@phantasmlimousineservice.com"
              data-testid="footer-email-link"
              className="block text-sm text-white hover:text-[#E6E6E6] transition-colors"
            >
              reservations@phantasmlimousineservice.com
            </a>
            <a
              href={DISPATCH_TEL_HREF}
              data-testid="footer-phone-link"
              className="block text-sm text-white hover:text-[#E6E6E6] transition-colors"
            >
              {DISPATCH_PHONE_DISPLAY}
            </a>
            <a
              href="https://www.phantasmlimousineservice.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-website-link"
              className="block text-[11px] uppercase tracking-[0.28em] text-[#8E9AA6] hover:text-white transition-colors pt-2"
            >
              WWW.PHANTASMLIMOUSINESERVICE.COM
            </a>
          </div>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#8E9AA6] mb-5">
            New York
          </div>
          <ul className="space-y-2">
            {NY_REGIONS.map((r) => (
              <li key={r} className="text-sm text-white/70">
                {r}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#8E9AA6] mb-5">
            Massachusetts
          </div>
          <ul className="space-y-2">
            {MA_REGIONS.map((r) => (
              <li key={r} className="text-sm text-white/70">
                {r}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-[#8E9AA6]">
            © {new Date().getFullYear()} Phantasm Limousine Service Inc. All rights reserved.
          </div>
          <div className="flex gap-6">
            <Link
              to="/fleet"
              data-testid="footer-fleet-link"
              className="text-xs uppercase tracking-[0.2em] text-[#8E9AA6] hover:text-white transition-colors"
            >
              Fleet
            </Link>
            <Link
              to="/pricing"
              data-testid="footer-rates-link"
              className="text-xs uppercase tracking-[0.2em] text-[#8E9AA6] hover:text-white transition-colors"
            >
              Rates
            </Link>
            <Link
              to="/book"
              data-testid="footer-book-link"
              className="text-xs uppercase tracking-[0.2em] text-[#8E9AA6] hover:text-white transition-colors"
            >
              Reserve
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
